export const creditTransactionCodes = {
    '108': 'Debit Card Purchase / Correction',
    '114': 'Lockbox Deposit',
    '115': 'Lockbox Deposit',
    '116': 'Item in Lockbox Deposit',
    '118': 'Lockbox Adjustment Credit',
    '121': 'EDI Transaction',
    '122': 'EDIBANX Credit Received',
    '123': 'EDIBANX Credit Return',
    '135': 'DTC Concentration Credit',
    '136': 'Item in DTC Deposit',
    '142': 'Direct Deposit',
    '143': 'Item in ACH Deposit',
    '145': 'ACH Concentration Credit',
    '147': 'Merchant Deposit / Adjustment',
    '155': 'Preauthorized Draft Credit',
    '156': 'Item in PAC Deposit',
    '164': 'Corporate Trade Payment Credit',
    '165': 'Preauthorized Credit / Correction',
    '166': 'ACH Settlement',
    '168': 'Returned Item',
    '169': 'Misc ACH Credit',
    '171': 'Loan Advance',
    '172': 'Deposit Correction',
    '173': 'Bank-Prepared Deposit',
    '174': 'Deposit',
    '175': 'Cheque Deposit',
    '176': 'Re-Presented Check Deposit',
    '184': 'Draft Deposit',
    '187': 'Cash Letter',
    '189': 'Cash Letter Adjustment',
    '191': 'Individual Incoming Internal Money Transfer',
    '195': 'Incoming Wire Payment',
    '196': 'INTERAC Email Money Transfer Received',
    '198': 'Compensation',
    '199': 'Waived Domestic Wire Transfer Fee',
    '201': 'Automated Transfer',
    '202': 'Bond Operations Credit',
    '206': 'Transfer of Funds',
    '208': 'Wire Payment',
    '212': 'Foreign Letter Of Credit',
    '213': 'Letter Of Credit',
    '214': 'Foreign Exchange',
    '216': 'Foreign Remittance Credit',
    '218': 'Foreign Collection Credit',
    '221': 'Foreign Exchange Cheque',
    '222': 'Foreign Checks Deposited',
    '224': 'Commission',
    '226': 'International Money Market Trading',
    '227': 'Standing Order',
    '229': 'Miscellaneous International Credit',
    '232': 'Sale of Debt Security',
    '233': 'Securities Sold',
    '234': 'Sale of Equity Security',
    '235': 'Matured Reverse Repurchase Order',
    '236': 'Maturity of Debt Security',
    '237': 'Collection Credit',
    '238': 'Collection of Dividends',
    '240': 'Coupon Collections - Banks',
    '241': 'Bankers Acceptances',
    '242': 'Collection of Interest Income',
    '243': 'Matured Fed Funds Purchased',
    '244': 'Interest/Matured Principal Payment',
    '246': 'Commercial Paper',
    '247': 'Capital Change',
    '248': 'Savings Bonds Sales Adjustment',
    '249': 'Nesbitt Credit Entry',
    '252': 'Debit Memo / Correction',
    '254': 'Error Correction',
    '255': 'NSF',
    '257': 'Individual ACH Return Item',
    '258': 'ACH Reversal Credit',
    '261': 'Individual Rejected Credit',
    '263': 'Overdraft / Adjustment',
    '266': 'Returned Item',
    '268': 'Return Item Adjustment',
    '274': 'Cumulative ZBA Or Disbursement Credits',
    '275': 'Zero Balance Credit',
    '276': 'CMA float adjustment',
    '277': 'CMA credit transfer',
    '278': 'ZBA Credit Adjustment',
    '281': 'Disbursement credit',
    '286': 'Individual DTC Disbursing Credit',
    '295': 'ATM Credit',
    '301': 'Commercial Deposit',
    '306': 'FED Funds Sold',
    '308': 'Trust Credit',
    '331': 'Individual Escrow Credit',
    '342': 'Broker Deposit',
    '344': 'Individual Back Value Credit',
    '345': 'Item in Brokers Deposit',
    '346': 'Sweep Transaction',
    '347': 'Sweep Transaction',
    '348': 'Futures Credit',
    '349': 'Principal Payments Credit',
    '351': 'Investment / Adjustment',
    '353': 'Withdrawal / Correction',
    '354': 'Interest / Adjustment',
    '357': 'Adjustment',
    '358': 'YTD Adjustment Credit',
    '359': 'Interest / Adjust',
    '362': 'Correspondent Collection',
    '363': 'Correspondent Collection Adjustment',
    '364': 'Loan Participation',
    '366': 'Currency and Coin Deposited',
    '367': 'Food Stamp Letter',
    '368': 'Food Stamp Adjustment',
    '369': 'Clearing Settlement Credit',
    '372': 'Back Value Adjustment',
    '373': 'Customer Payroll',
    '374': 'FRB Statement Recap',
    '376': 'Savings Bond Letter Or Adjustment',
    '377': 'Treasury Tax and Loan Credit',
    '378': 'Transfer of Treasury Credit',
    '379': 'FRB Government Checks Cash Letter Credit',
    '381': 'FRB Government Check Adjustment',
    '382': 'FRB Postal Money Order Credit',
    '383': 'FRB Postal Money Order Adjustment',
    '384': 'FRB Cash Letter Auto Charge Credit',
    '386': 'FRB Cash Letter Auto Charge Adjustment',
    '387': 'FRB Fine-Sort Cash Letter Credit',
    '388': 'FRB Fine-Sort Adjustment',
    '391': 'Universal Credit',
    '392': 'Freight Payment Credit',
    '393': 'Itemized Credit Over $10,000',
    '394': 'FACS/DCH List Post',
    '395': 'Cheque Reversal',
    '397': 'Float Adjustment',
    '398': 'Service Charge / Correction',
    '399': 'Credit Memo',
    '920': 'Bill Payment / Correction',
    '921': 'Air Miles Direct Deposit',
    '922': 'Air Miles Merchandise Return',
    '923': 'INTERAC Email Money Transfer Cancelled',
    '924': 'NSF Fee / Correction',
    '925': 'Merchandise Return',
    '926': 'Merchant Reversal / Correction',
    '927': 'FCCS Credit / Correction',
    '928': 'FBPS Credit / Correction',
    '929': 'FBPS Transfer',
    '930': 'Multi Branch Credit',
    '932': 'Loan Payment / Adjustment',
    '935': 'Remote Deposit Package',
    '937': 'Drawcheque',
    '944': 'GST/ HST Refund',
    '945': 'Mail Deposit',
    '946': 'Teller Deposit',
    '947': 'Certified Cheque',
    '950': 'Decrease Collected Balance',
    '951': 'Non Resident Tax',
    '952': 'FCCS Reversal / Correction',
    '955': 'Loan Interest / Adjustment',
    '956': 'Debit Card Purchase / Correction',
    '957': 'Insurance Premium / Adjustment',
    '958': 'Debit Card Cash Back / Correction',
    '959': 'Fees / Correction',
    '998': 'HIP CR float',
};

export const debitTransactionCodes = {
    '408': 'Float Adjustment',
    '409': 'Bill Payment',
    '415': 'Lockbox Debit',
    '421': 'EDI Transaction',
    '422': 'EDIBANX Settlement Debit',
    '423': 'EDIBANX Return Item Debit',
    '435': 'Payable-Through Draft',
    '445': 'ACH Concentration Debit',
    '447': 'ACH Funding Debit',
    '451': 'Direct Deposit / Correction',
    '452': 'Item in ACH Disbursement or Debit',
    '455': 'Preauthorized Debit / Correction',
    '462': 'Account Holder Initiated ACH Debit',
    '464': 'Corporate Trade Payment Debit',
    '466': 'ACH Settlement',
    '468': 'Returned Item',
    '469': 'Misc ACH Debit',
    '472': 'Cumulative Checks Paid',
    '474': 'Certified Cheque',
    '475': 'Cheque',
    '476': 'Federal Reserve Bank Letter Debit',
    '477': 'Bank Originated Debit',
    '479': 'List Post Debit',
    '481': 'Loan Payment',
    '484': 'Draft',
    '485': 'DTC Debit',
    '487': 'Cash Letter',
    '489': 'Cash Letter Adjustment',
    '491': 'Individual Outgoing Internal Money Transfer',
    '493': 'Customer Terminal Initiated Money Transfer',
    '495': 'Outgoing Wire Payment',
    '496': 'INTERAC Email Money Transfer Sent',
    '497': 'Wire Transfer Fee',
    '498': 'Compensation',
    '501': 'Automated Transfer',
    '502': 'Bond Operations Debit',
    '506': 'Transfer of Funds',
    '508': 'Wire Transfer',
    '512': 'Letter Of Credit Debit',
    '513': 'Letter Of Credit',
    '514': 'Foreign Exchange',
    '516': 'Foreign Remittance Debit',
    '518': 'Foreign Collection Debit',
    '522': 'Foreign Exchange Cheque',
    '524': 'Commission',
    '526': 'International Money Market Trading',
    '527': 'Standing Order',
    '529': 'Miscellaneous International Debit',
    '531': 'Securities Purchased',
    '533': 'Security Collection Debit',
    '535': 'Purchase Of Equity Securities',
    '538': 'Matured Repurchase Order',
    '540': 'Coupon Collection Debit',
    '541': 'Bankers Acceptances',
    '542': 'Purchase Of Debt Securities',
    '543': 'Domestic Collection',
    '544': 'Interest/Matured Principal Payment',
    '546': 'Commercial Paper',
    '547': 'Capital Change',
    '548': 'Savings Bonds Sales Adjustment',
    '549': 'Nesbitt Debit Entry',
    '552': 'Credit Memo / Correction',
    '554': 'Error Correction',
    '555': 'Returned Item',
    '557': 'Individual ACH Return Item',
    '558': 'ACH Reversal Debit',
    '561': 'Individual Rejected Debit',
    '563': 'Overdraft Transfer / Adjustment',
    '564': 'Overdraft Fee',
    '566': 'Returned Item',
    '567': 'NSF Fee',
    '568': 'Return Item Adjustment',
    '574': 'Cumulative ZBA Or Disbursement Debits',
    '575': 'Zero Balance Debit',
    '577': 'ZBA Debit Transfer',
    '578': 'ZBA Debit Adjustment',
    '581': 'Individual Controlled Disbursing Debit',
    '582': 'Individual Controlled Disbursement Late',
    '595': 'ATM Debit',
    '597': 'ARP Debit',
    '616': 'Federal Reserve Bank - Commercial Bank Debit',
    '622': 'Broker Debit',
    '627': 'FED Funds Purchased',
    '629': 'Cash Center Debit',
    '631': 'Adjustment',
    '633': 'Trust Debit',
    '634': 'YTD Adjustment Debit',
    '641': 'Individual Escrow Debit',
    '644': 'Individual Back Value Debit',
    '651': 'Investment / Adjustment',
    '654': 'Interest / Adjustment',
    '656': 'Sweep Transaction',
    '657': 'Futures Debit',
    '658': 'Principal Payments Debit',
    '659': 'Interest / Adjust',
    '661': 'Account Analysis Fee',
    '662': 'Correspondent Collection Debit',
    '663': 'Correspondent Collection Adjustment',
    '664': 'Loan Participation',
    '666': 'Currency and Coin Shipped',
    '667': 'Food Stamp Letter',
    '668': 'Food Stamp Adjustment',
    '669': 'Clearing Settlement Debit',
    '672': 'Back Value Adjustment',
    '673': 'Customer Payroll',
    '674': 'FRB Statement Recap',
    '676': 'Saving Bond Letter Or Adjustment',
    '677': 'Treasury Tax And Loan Debit',
    '678': 'Transfer Of Treasury Debit',
    '679': 'FRB Government Check Cash Letter Debit',
    '681': 'FRB Government Check Adjustment',
    '682': 'FRB Postal Money Order Debit',
    '683': 'FRB Postal Money Order Adjustment',
    '684': 'FRB Cash Letter Auto Charge Debit',
    '686': 'FRB Cash Letter Auto Charge Adjustment',
    '687': 'FRB Fine-Sort Cash Letter Debit',
    '688': 'FRB Fine-Sort Adjustment',
    '691': 'Universal Debit',
    '692': 'Freight Payment Debit',
    '693': 'Itemized Debit Over $10,000',
    '694': 'Deposit / Correction',
    '695': 'Deposit / Correction',
    '696': 'Regular Collection',
    '697': 'FAC/DCH List Total',
    '698': 'Service Charge',
    '699': 'Debit Memo',
    '721': 'Amount Applied to Interest',
    '722': 'Amount Applied to Principle',
    '723': 'Amount Applied to Escrow',
    '724': 'Amount Applied to Late Charges',
    '725': 'Amount Applied to Buydown',
    '726': 'Amount Applied to Misc. Fees',
    '727': 'Amount Applied to Deferred Interest Detail',
    '728': 'Amount Applied to Service Charge',
    '730': 'Monthly Ser. Debit Detail',
    '960': 'Air Miles Merchandise Return',
    '961': 'Air Miles Direct Deposit / Correction',
    '964': 'Withdrawal',
    '965': 'Debit Card Purchase',
    '966': 'Merchandise Return',
    '967': 'Merchant Reversal / Correction',
    '968': 'FCCS Deposit / Correction',
    '969': 'FCCS Debit / Correction',
    '970': 'FBPS Debit / Correction',
    '971': 'FBPS Transfer / Correction',
    '972': 'FACS/DCH List Post',
    '974': 'GST/ HST',
    '975': 'NSF',
    '977': 'Drawcheque',
    '979': 'FEE',
    '982': 'FCCS Reversal',
    '984': 'FBPS Reversal',
    '985': 'Loan Interest',
    '987': 'Debit Card Cash Back',
    '988': 'Loan Advance / Adjustment',
    '989': 'Insurance Premium',
    '990': 'Multi Branch Debit',
    '991': 'Non Resident Tax',
    '995': 'Merchant Deposit / Adjustment',
};
